const base = {}

// 手动修改请求域名
// const DEVAPI = 'https://devapi.chinachdu.com'  // 开发环境API
// const DEVAPI = "https://test.chinachdu.com"; // 测试环境
// const DEVAPI = "https://ihos.chinachdu.com";  // 生产环境

base.baseUrl = process.env.API_ROOT
base.appCode = process.env.appCode
base.payMethod = process.env.payMethod
// console.log('NODE_ENV', process.env.NODE_ENV);
// console.log('base', base);
export default base



// WEBPACK FOOTER //
// ./src/api/base.js